import React, { useEffect, useState } from "react";
import Slider from "react-input-slider";
import "./App.scss";
function App() {
  const [age, setAge] = useState({ x: 15 });
  const [is_woman, setSex] = useState(1);
  // selects option values
  const [smoke, setSmoke] = useState();
  const [cholesterol, setCholesterol] = useState();
  const [pressure, setPressure] = useState();
  const [hdl, setHdl] = useState();
  const [systolic, setSystolic] = useState();
  var points = 0;
  var risk = 0;
  // age
  let onSliding = ({ x }) => {
    setAge((age) => ({ ...age, x }));
    document.getElementById("age-input-slid").value = "iam here";
    console.log();
  };
  let ageInput = (event) => {
    const newValue = event.target.value;
    setAge({ x: newValue });
    // age.x = event.target.value;
    // console.log(newValue);
    // console.log(age.x);
  };

  // result
  function calculateHandler() {
    if (is_woman == 1) {
      switch (
        true //the X mean age
      ) {
        case age.x <= 39: //points calculation depending on Age,Smoker,Cholesterol for age <39
          {
            smoke == 1 ? (points += 9) : (points += 0);
          }
          if (age.x <= 34) {
            points -= 7;

            switch (true) {
              case cholesterol < 160:
                points += 0;

                break;
              case cholesterol <= 199:
                points += 4;

                break;
              case cholesterol <= 239:
                points += 8;
                break;
              case cholesterol <= 279:
                points += 11;
                break;
              default:
                points += 13;
            }
          } else {
            points -= 3;
            switch (true) {
              case cholesterol < 160:
                points -= 0;
                break;
              case cholesterol <= 199:
                points -= 4;
                break;
              case cholesterol <= 239:
                points -= 8;
                break;
              case cholesterol <= 279:
                points -= 11;
                break;
              default:
                points -= 13;
            }
          }
          break;
        case age.x <= 49: //points calculation depending on Age,Smoker,Cholesterol<49
          {
            smoke == 1 ? (points += 7) : (points += 0);
          }
          if (age.x <= 44) {
            points += 0;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 3;
                break;
              case cholesterol <= 239:
                points += 6;
                break;
              case cholesterol <= 279:
                points += 8;
                break;
              default:
                points += 10;
            }
          } else {
            points += 3;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 3;
                break;
              case cholesterol <= 239:
                points += 6;
                break;
              case cholesterol <= 279:
                points += 8;
                break;
              default:
                points += 10;
            }
          }
          break;
        case age.x <= 59: //points calculation depending on Age,Smoker,Cholesterol<59
          {
            smoke == 1 ? (points += 4) : (points += 0);
          }
          if (age.x <= 54) {
            points += 6;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 2;
                break;
              case cholesterol <= 239:
                points += 4;
                break;
              case cholesterol <= 279:
                points += 5;
                break;
              default:
                points += 7;
            }
          } else {
            points += 8;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 2;
                break;
              case cholesterol <= 239:
                points += 4;
                break;
              case cholesterol <= 279:
                points += 5;
                break;
              default:
                points += 7;
            }
          }
          break;
        case age.x <= 69: //points calculation depending on Age,Smoker,Cholesterol<69
          {
            smoke == 1 ? (points += 2) : (points += 0);
          }
          if (age.x <= 64) {
            points += 10;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 1;
                break;
              case cholesterol <= 239:
                points += 2;
                break;
              case cholesterol <= 279:
                points += 3;
                break;
              default:
                points += 4;
            }
          } else {
            points += 12;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 1;
                break;
              case cholesterol <= 239:
                points += 2;
                break;
              case cholesterol <= 279:
                points += 3;
                break;
              default:
                points += 4;
            }
          }
          break;
        case age.x <= 100: //points calculation depending on Age,Smoker,Cholesterol<79
          {
            smoke == 1 ? (points += 1) : (points += 0);
          }
          if (age.x <= 74) {
            points += 14;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 1;
                break;
              case cholesterol <= 239:
                points += 1;
                break;
              case cholesterol <= 279:
                points += 2;
                break;
              default:
                points += 2;
            }
          } else {
            points += 16;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 1;
                break;
              case cholesterol <= 239:
                points += 1;
                break;
              case cholesterol <= 279:
                points += 2;
                break;
              default:
                points += 2;
            }
          }
      }

      switch (
        true //HDL CHolesterol
      ) {
        case hdl < 40: //points calculation depending on HDL Cholesterol
          points += 2;
          break;
        case hdl <= 49:
          points += 1;
          break;
        case hdl <= 59:
          points += 0;
          break;
        default:
          points -= 1;
      }
      switch (
        true //HDL Systolic Blood Pressure
      ) {
        case systolic < 120: //points calculation depending on HDL Systolic Blood Pressure
          points += 0;
          break;
        case systolic <= 129:
          points += 1;
          break;
        case systolic <= 139:
          points += 2;
          break;
        case systolic <= 159:
          points += 3;
          break;
        default:
          points += 4;
      }
      switch (true) {
        case points < 9:
          risk = "פחות מ  1%";
          break;
        case points <= 12:
          risk = "1%";
          break;
        case points <= 14:
          risk = "2%";
          break;
        case points == 15:
          risk = "3%";
          break;
        case points == 16:
          risk = "4%";
          break;
        case points == 17:
          risk = "5%";
          break;
        case points == 18:
          risk = "6%";
          break;
        case points == 19:
          risk = "8%";
          break;
        case points == 20:
          risk = "11%";
          break;
        case points == 21:
          risk = "14%";
          break;
        case points == 22:
          risk = "17%";
          break;
        case points == 23:
          risk = "22%";
          break;
        case points == 24:
          risk = "27%";
          break;
        default:
          risk = "מעל  30%";
      }
      if (points <= 17) {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `
       נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות נמוך יחסית והדבר מעיד על
  כך שאת שומרת טוב יחסית על בריאותך. עם זאת, חשוב כי תעקבי באופן סדיר אחר המדדים
  הבריאותיים הרלוונטיים ותישארי בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול
  ה"רע"), כלומר ערכים הנמוכים מ-160 ml/dL. בכל מקרה, המטרה העיקרית שאת צריכה
  לשים לעצמך היא צמצום הסיכון לטווח הארוך ולשם כך מומלץ כי תאמצי אורח חיים בריא
  יותר הכולל תזונה בריאה יותר הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל
  במידת הצורך) ופעילות גופנית סדירה.
        `;
        console.log(womenDesc);
      } else if (points <= 19) {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `
          נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות הוא בין 5%-10%. לאור
  התוצאות, חשוב כי תעקבי באופן סדיר אחר המדדים הבריאותיים הרלוונטיים ותישארי
  בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול ה"רע"), כלומר ערכים הנמוכים
  מ-130 ml/dL. בכל מקרה, המטרה העיקרית שאת צריכה לשים לעצמך היא צמצום הסיכון
  לטווח הארוך ולשם כך מומלץ כי תאמצי אורח חיים בריא יותר הכולל תזונה בריאה יותר
  הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל במידת הצורך) ופעילות גופנית
  סדירה.
          `;
      } else if (points <= 22) {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `  נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות הוא בין 10%-20%. לאור
  התוצאות, חשוב כי תעקבי באופן סדיר אחר המדדים הבריאותיים הרלוונטיים ותישארי
  בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול ה"רע"), כלומר ערכים הנמוכים
  מ-130 ml/dL. בכל מקרה, המטרה העיקרית שאת צריכה לשים לעצמך היא צמצום הסיכון
  לטווח הארוך ולשם כך מומלץ כי תאמצי אורח חיים בריא יותר הכולל תזונה בריאה יותר
  הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל במידת הצורך) ופעילות גופנית
  סדירה. עם זאת, במידה והשינוי באורח החיים לא הוריד את רמת הכולסטרול לרמה
  הרצויה, מומלץ כי תתייעצי עם הרופא שלך לגבי טיפול תרופתי/אחר להקטנת הסיכון.`;
      } else {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `  נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות הוא גבוה מ-20%. לאור
  התוצאות, חשוב כי תעקבי באופן סדיר אחר המדדים הבריאותיים הרלוונטיים ותישארי
  בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול ה"רע"), כלומר ערכים הנמוכים
  מ-100 ml/dL. בכל מקרה, המטרה העיקרית שאת צריכה לשים לעצמך היא צמצום הסיכון
  לטווח הארוך ולשם כך מומלץ כי תאמצי אורח חיים בריא יותר הכולל תזונה בריאה יותר
  הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל במידת הצורך) ופעילות גופנית
  סדירה. כמו כן, בשל הסיכון הגבוה בו את נמצאת, מומלץ כי תתייעצי עם הרופא שלך
  לגבי טיפול תרופתי/אחר להקטנת הסיכון.`;
      }
      var container = document.getElementById("printHere");
      container.innerHTML = risk;
      var container = document.getElementById("printHereTitle");
      container.innerHTML = "הסיכוי שלך לקבל התקף לב ב-10 שנים הקרובות עומד על";
    }
    /////////////////////////////////////////////////////////////////////////// it is a man/////////////////////////////////////////////
    else if (is_woman == 0) {
      switch (
        true //the X mean age
      ) {
        case age.x <= 39: //points calculation depending on Age,Smoker,Cholesterol for age <39
          {
            smoke == 1 ? (points += 8) : (points += 0);
          }
          if (age.x <= 34) {
            points -= 9;

            switch (true) {
              case cholesterol < 160:
                points += 0;

                break;
              case cholesterol <= 199:
                points += 4;

                break;
              case cholesterol <= 239:
                points += 7;
                break;
              case cholesterol <= 279:
                points += 9;
                break;
              default:
                points += 11;
            }
          } else {
            points -= 4;
            switch (true) {
              case cholesterol < 160:
                points += 0;

                break;
              case cholesterol <= 199:
                points += 4;

                break;
              case cholesterol <= 239:
                points += 7;
                break;
              case cholesterol <= 279:
                points += 9;
                break;
              default:
                points += 11;
            }
          }
          break;
        case age.x <= 49: //points calculation depending on Age,Smoker,Cholesterol<49
          {
            smoke == 1 ? (points += 5) : (points += 0);
          }
          if (age.x <= 44) {
            points += 0;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 3;
                break;
              case cholesterol <= 239:
                points += 5;
                break;
              case cholesterol <= 279:
                points += 6;
                break;
              default:
                points += 8;
            }
          } else {
            points += 3;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 3;
                break;
              case cholesterol <= 239:
                points += 5;
                break;
              case cholesterol <= 279:
                points += 6;
                break;
              default:
                points += 8;
            }
          }
          break;
        case age.x <= 59: //points calculation depending on Age,Smoker,Cholesterol<59
          {
            smoke == 1 ? (points += 3) : (points += 0);
          }
          if (age.x <= 54) {
            points += 6;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 2;
                break;
              case cholesterol <= 239:
                points += 3;
                break;
              case cholesterol <= 279:
                points += 4;
                break;
              default:
                points += 5;
            }
          } else {
            points += 8;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 2;
                break;
              case cholesterol <= 239:
                points += 3;
                break;
              case cholesterol <= 279:
                points += 4;
                break;
              default:
                points += 5;
            }
          }
          break;
        case age.x <= 69: //points calculation depending on Age,Smoker,Cholesterol<69
          {
            smoke == 1 ? (points += 1) : (points += 0);
          }
          if (age.x <= 64) {
            points += 10;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 1;
                break;
              case cholesterol <= 239:
                points += 1;
                break;
              case cholesterol <= 279:
                points += 2;
                break;
              default:
                points += 3;
            }
          } else {
            points += 11;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 1;
                break;
              case cholesterol <= 239:
                points += 1;
                break;
              case cholesterol <= 279:
                points += 2;
                break;
              default:
                points += 3;
            }
          }
          break;
        case age.x <= 100: //points calculation depending on Age,Smoker,Cholesterol<79
          {
            smoke == 1 ? (points += 1) : (points += 0);
          }
          if (age.x <= 74) {
            points += 12;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 0;
                break;
              case cholesterol <= 239:
                points += 0;
                break;
              case cholesterol <= 279:
                points += 1;
                break;
              default:
                points += 1;
            }
          } else {
            points += 16;
            switch (true) {
              case cholesterol < 160:
                points += 0;
                break;
              case cholesterol <= 199:
                points += 0;
                break;
              case cholesterol <= 239:
                points += 0;
                break;
              case cholesterol <= 279:
                points += 1;
                break;
              default:
                points += 1;
            }
          }
      }

      switch (
        true //HDL CHolesterol
      ) {
        case hdl < 40: //points calculation depending on HDL Cholesterol
          points += 2;
          break;
        case hdl <= 49:
          points += 1;
          break;
        case hdl <= 59:
          points += 0;
          break;
        default:
          points -= 1;
      }
      switch (
        true //HDL Systolic Blood Pressure
      ) {
        case systolic < 120: //points calculation depending on HDL Systolic Blood Pressure
          points += 0;
          break;
        case systolic <= 129:
          points += 0;
          break;
        case systolic <= 139:
          points += 1;
          break;
        case systolic <= 159:
          points += 1;
          break;
        default:
          points += 2;
      }
      switch (true) {
        case points == 0:
          risk = "פחות מ  1%";
          break;
        case points <= 4:
          risk = "1%";
          break;
        case points <= 6:
          risk = "2%";
          break;
        case points == 7:
          risk = "3%";
          break;
        case points == 8:
          risk = "4%";
          break;
        case points == 9:
          risk = "5%";
          break;
        case points == 10:
          risk = "6%";
          break;
        case points == 11:
          risk = "8%";
          break;
        case points == 12:
          risk = "10%";
          break;
        case points == 13:
          risk = "12%";
          break;
        case points == 14:
          risk = "16%";
          break;
        case points == 15:
          risk = "20%";
          break;
        case points == 16:
          risk = "25%";
          break;
        default:
          risk = "מעל  30%";
      }
      if (points <= 9) {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `  נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות נמוך יחסית והדבר מעיד על
  כך שאתה שומר טוב יחסית על בריאותך. עם זאת, חשוב כי תעקוב באופן סדיר אחר המדדים
  הבריאותיים הרלוונטיים ותישאר בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול
  ה"רע"), כלומר ערכים הנמוכים מ-160 ml/dL. בכל מקרה, המטרה העיקרית שאתה צריך
  לשים לעצמך היא צמצום הסיכון לטווח הארוך ולשם כך מומלץ כי תאמץ אורח חיים בריא
  יותר הכולל תזונה בריאה יותר הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל
  במידת הצורך) ופעילות גופנית סדירה.
    `;
      } else if (points <= 12) {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `
  נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות הוא בין 5%-10%. לאור
  התוצאות, חשוב כי תעקוב באופן סדיר אחר המדדים הבריאותיים הרלוונטיים ותישאר
  בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול ה"רע"), כלומר ערכים הנמוכים
  מ-130 ml/dL. בכל מקרה, המטרה העיקרית שאתה צריך לשים לעצמך היא צמצום הסיכון
  לטווח הארוך ולשם כך מומלץ כי תאמץ אורח חיים בריא יותר הכולל תזונה בריאה יותר
  הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל במידת הצורך) ופעילות גופנית
  סדירה.

        `;
      } else if (points <= 15) {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `  נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות הוא בין 10%-20%. לאור
  התוצאות, חשוב כי תעקוב באופן סדיר אחר המדדים הבריאותיים הרלוונטיים ותישאר
  בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול ה"רע"), כלומר ערכים הנמוכים
  מ-130 ml/dL. בכל מקרה, המטרה העיקרית שאתה צריך לשים לעצמך היא צמצום הסיכון
  לטווח הארוך ולשם כך מומלץ כי תאמץ אורח חיים בריא יותר הכולל תזונה בריאה יותר
  הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל במידת הצורך) ופעילות גופנית
  סדירה. עם זאת, במידה והשינוי באורח החיים לא הוריד את רמת הכולסטרול לרמה
  הרצויה, מומלץ כי תתייעץ עם הרופא שלך לגבי טיפול תרופתי/אחר להקטנת הסיכון.`;
      } else {
        var womenDescTitle = document.getElementById("description-title");
        womenDescTitle.innerHTML = "המלצות:";
        var womenDesc = document.getElementById("description");
        womenDesc.innerHTML = `  נראה כי הסיכון שלך לחלות במחלת לב ב-10 השנים הקרובות הוא גבוה מ-20%. לאור
  התוצאות, חשוב כי תעקוב באופן סדיר אחר המדדים הבריאותיים הרלוונטיים ותישאר
  בטווחים המומלצים של כולסטרול ה-LDL (הכולסטרול ה"רע"), כלומר ערכים הנמוכים
  מ-100 ml/dL. בכל מקרה, המטרה העיקרית שאתה צריך לשים לעצמך היא צמצום הסיכון
  לטווח הארוך ולשם כך מומלץ כי תאמץ אורח חיים בריא יותר הכולל תזונה בריאה יותר
  הדלה בשומן רווי ובכולסטרול, בקרת משקל (ירידה במשקל במידת הצורך) ופעילות גופנית
  סדירה. כמו כן, בשל הסיכון הגבוה בו אתה נמצא, מומלץ כי תתייעץ עם הרופא שלך לגבי
  טיפול תרופתי/אחר להקטנת הסיכון.`;
      }
      var container = document.getElementById("printHere");
      container.innerHTML = risk;
      var container = document.getElementById("printHereTitle");
      container.innerHTML = "הסיכוי שלך לקבל התקף לב ב-10 שנים הקרובות עומד על";
    } else {
      var container = document.getElementById("printHere");
      container.innerHTML = "נא בחר מגדר";
    }
    /////////////////////////////////////////////////////////////////
    // The risk of 10 Years
    points = 0;
    // var d = document.getElementById("contact-popup");
    // d.className += " show";
  }
  return (
    <>
      <div className="container">
        <div className="calcualtor-container">
          <div className="calcualtor">
            {/* gender box */}
            <div className="gender" onChange={(e) => setSex(e.target.value)}>
              {/* Sex */}
              <div className="sex">
                <img src="/calculator/images/female.png" />
                <div className="btn-center">
                  {" "}
                  <input
                    type="radio"
                    id="female"
                    name="gender"
                    value="1"
                    defaultChecked
                  />
                  <label htmlFor="female">אישה</label>
                </div>
              </div>

              <div className="sex">
                <img src="/calculator/images/male.png" />
                <div className="btn-center">
                  <input
                    type="radio"
                    id="male"
                    name="gender"
                    value="0"
                    // checked="checked"
                  />
                  <label htmlFor="male">איש</label>
                </div>
              </div>
            </div>
            {/* Age */}
            <div className="age">
              <p>גיל</p>
              <Slider
                xreverse={true}
                xmin={15}
                xmax={95}
                styles={{
                  active: {
                    backgroundColor: "gray",
                  },
                  thumb: {
                    width: 10,
                    height: 10,
                  },
                  disabled: {
                    opacity: 0.5,
                  },
                }}
                axis="x"
                x={age.x}
                onChange={onSliding} // https://www.npmjs.com/package/react-input-slider
              />
              <div className="age-results">
                <input
                  id="age-input-slid"
                  className="age-input"
                  type="number"
                  placeholder={age.x}
                  onChange={ageInput}
                />
                <p className="sub"> ניתן להזין ידנית</p>{" "}
              </div>
            </div>
            {/* Qustions */}
            <div className="qustions">
              <div className="qustions-wrapper">
                <label htmlFor="smoke">האם אתה מעשן?</label>
                <select
                  name="smoke"
                  id="smoke"
                  // value={selects}
                  onChange={(e) => setSmoke(e.target.value)}
                >
                  <option value="0">לא</option>
                  <option value="1">כן</option>
                </select>
              </div>
              <div className="qustions-wrapper">
                <label htmlFor="pressure">
                  האם אתה משתמש/ת בתרופות ללחץ דם גבוה?
                </label>
                <select
                  name="pressure"
                  id="pressure"
                  onChange={(e) => setPressure(e.target.value)}
                >
                  <option value="0">לא</option>
                  <option value="1">כן</option>
                </select>
              </div>
              <div className="qustions-wrapper">
                <label htmlFor="cholesterol">סה"כ כולסטרול בדם</label>
                <select
                  name="cholesterol"
                  id="cholesterol"
                  onChange={(e) => setCholesterol(e.target.value)}
                >
                  <option value="159">מתחת ל-160</option>
                  <option value="199">160-199</option>
                  <option value="239">200-239</option>
                  <option value="279">240-279</option>
                  <option value="280">280 ומעלה</option>
                </select>
              </div>
              <div className="qustions-wrapper">
                <label htmlFor="hdl"> רמת כולסטרול ה- HDL (הטוב) שלכם:</label>
                <select
                  name="hdl"
                  id="hdl"
                  onChange={(e) => setHdl(e.target.value)}
                >
                  <option value="39">מתחת ל-40</option>
                  <option value="49">40-49</option>
                  <option value="59">50-59</option>
                  <option value="60">60 ומעלה </option>
                </select>
              </div>
              <div className="qustions-wrapper">
                <label htmlFor="systolic">
                  ערך לחץ הדם הסיסטולי (=הגבוה) שלכם:
                </label>
                <select
                  name="systolic"
                  id="systolic"
                  onChange={(e) => setSystolic(e.target.value)}
                >
                  <option value="119">מתחת ל-120</option>
                  <option value="129">120-129</option>
                  <option value="139">130-139</option>
                  <option value="159">140-159</option>
                  <option value="160">160 ומעלה</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div className="results">
          <button onClick={() => calculateHandler()} className="calc-submit">
            חישוב סיכוי להתקף לב
          </button>
          <h4 id="printHereTitle"></h4>
          <p id="printHere"></p>
          <div className="results-description"></div>
        </div>
        <p id="description-title"></p>
        <dev id="description"></dev>
      </div>
    </>
  );
}

export default App;
